export default __webpack_public_path__ + "static/media/step3.342ade1c.mov";